<template>
  <div class="shopSearch">
    <search-result :pager="pager" :shops="shops" :pr_shops="pr_shops" :waiting="form.waiting" @next="search" />
  </div>
</template>

<script>
import SearchResult from './searchResult.vue';

export default {
    components: {
        'search-result': SearchResult
    },
    props: {
        people_from: {
            required: false,
            type: Number,
            default: null
        },
        price_to: {
            required: false,
            type: Number,
            default: null
        }
    },
    data: function() {
      return {
        form: this.createForm({
            people_from: this.people_from,
            price_to: this.price_to,
        }),
        pager: this.createPager(20),
        shops: [],
        pr_shops: [],
      };
    },
    created: function() {
        this.search();
    },
    methods: {
        search: function(opt_position) {
            var position = opt_position || this.pager.first();
            this.merge(this.form.model, position);
            this.form.model.page = parseInt(new URLSearchParams(window.location.search).get('page')) || 1;
            this.form.get('/api/shops', function(response) {
                this.shops = [];
                this.pr_shops = [];
                _.forEach(response.data['shops'], function(each) {
                    this.shops.push(each);
                }.bind(this));
                _.forEach(response.data['pr_shops'], function(each) {
                    this.pr_shops.push(each);
                }.bind(this));
                this.pager.update(response.data['shops'], response);
            });
        }
    }
}
</script>
